import { Transformations } from '../types'

export const prepareVideoSources = (transformations?: Transformations) => {
    if (!transformations) return []
    return Object.entries(transformations).map(([label, { url }]) => ({
        label,
        file: url,
    }))
}
